import * as merchant from './merchant'
import * as payment from './payment'
import * as user from './user'

;(window as any).API = {
  merchant,
  payment,
  user,
}
